import React, { Component } from 'react'
import { bindActionCreators } from 'redux'
import { connect } from 'react-redux'

import ContentHeader from '../common/template/contentHeader'
import Content from '../common/template/content'

import Tabs from '../common/tab/tabs'
import TabsHeader from '../common/tab/tabsHeader'
import TabsContent from '../common/tab/tabsContent'
import TabHeader from '../common/tab/tabHeader'
import TabContent from '../common/tab/tabContent'
import List from './usuarioList'
import Form from './usuarioForm'
import { init, create, update, remove } from './usuarioAction'

class Usuario extends Component {

  componentWillMount() {
   this.props.init()
  }


  render() {
    return (
      <div>
        <ContentHeader title='Usuários' small='Cadastros' />
        <Content>
          <Tabs>
            <TabsHeader>
              <TabHeader label='Listar' icon='bars' target='tabList' />
              <TabHeader label='Incluir' icon='plus' target='tabCreate' />
              <TabHeader label='Editar' icon='pencil' target='tabUpdate' />
              <TabHeader label='Excluir' icon='trash-o' target='tabDelete' />
            </TabsHeader>
            <TabsContent>
              <TabContent id='tabList'>
                <List />
              </TabContent>
              <TabContent id='tabCreate'>
                <Form onSubmit={this.props.create} 
                submitLabel='Salvar' submitClass='primary'
                iconSubmit ='save'/>
              </TabContent>
              <TabContent id='tabUpdate'>
                <Form onSubmit={this.props.update}
                submitLabel='Alterar' submitClass='info'
                iconSubmit ='pencil' />
              </TabContent>
              <TabContent id='tabDelete'>
                <Form onSubmit={this.props.remove} readOnly={true} 
                submitLabel='Deletar' submitClass='danger'
                iconSubmit ='trash-o'/>
              </TabContent>
            </TabsContent>
          </Tabs>
        </Content>
      </div>
    )
  }
}

const mapDispatchToProps = dispatch => bindActionCreators({init, create, update, remove }, dispatch)
export default connect(null, mapDispatchToProps)(Usuario)


// WEBPACK FOOTER //
// ./src/usuario/usuario.jsx